import React from 'react'
import _ from 'lodash'
import apiService from '../../services/api-id-value-service'
import LtsMultiselectIdValue from './lts-multiselect-id-value'

// O formulario manda a lista de unidades escolhidas, mas o recurso aceita um id so (com 2 ou mais a URL fica
// /usuarios/49,1262 e volta 404, sem opcoes). O back filtra os usuarios pela unidade: uma chamada por unidade,
// e os usuarios que estao em mais de uma entram uma vez.
export const carregarUsuarios = (oidsUnidades) => {
  if (!_.isArray(oidsUnidades) || oidsUnidades.length < 2) {
    return apiService.getUsuarios(_.isArray(oidsUnidades) ? _.head(oidsUnidades) : oidsUnidades)
  }
  return Promise.all(oidsUnidades.map((oidUnidade) => apiService.getUsuarios(oidUnidade))).then((respostas) => ({
    data: _.uniqBy(
      _.flatMap(respostas, (resposta) => _.get(resposta, 'data', [])),
      'id'
    ),
  }))
}

export default function LtsMultiselectUsuario(props) {
  return (
    <React.Fragment>
      <LtsMultiselectIdValue
        name={props.name}
        label={props.label}
        value={props.value}
        onChange={props.onChange}
        loadDataFn={carregarUsuarios}
        loadDataFnParam={props.loadDataFnParam}
      />
    </React.Fragment>
  )
}
